import moment from 'moment';

const formatNumber = (number) => {
  return (!!number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '');
}

const formatDate = (date) => {
  return (!!date ? moment(date).format('YYYY/MM/DD') : '');
}

module.exports = {
  formatDate,
  formatNumber
}



// WEBPACK FOOTER //
// ./src/helpers/formatters.jsx